import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import GoalValidations from 'scaleflow/validators/goal';

export default class QuickAddsGoalComponent extends Component {
  @service store;
  @service router;

  goal = {
    title: '',
  };

  goalValidations = GoalValidations;

  @action
  async onSubmit(changeset, e) {
    e.preventDefault();
    try {
      await changeset.validate();
      if (changeset.isInvalid) {
        console.debug(changeset.errors);
        return;
      }
      const goal = this.store.createRecord('goal', {
        title: changeset.title,
      });
      await goal.save();
      this.args?.onItemSaved(goal);
      this.handleModalDismiss();
    } catch (err) {
      console.log(err);
    }
  }

  @action
  handleModalDismiss() {
    this.args?.handleFormDismiss();
  }
}
